import styled from 'styled-components';
import Colors from '../../../assets/Colors';

const IconContainer = styled.div`
  cursor: pointer;
`;

const Header = styled.div`
  border-bottom: 2px solid ${Colors.line_separator};
`;

const HeaderTopItems = styled.div`
  display: flex;
  padding-top: 21px;
  padding-bottom: 15px;
  padding-left: 41px;
  padding-right: 26px;
  justify-content: center;
  align-items: center;
`;

const TitleContainer = styled.div`
  color: ${Colors.text_primary};
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.01em;
  flex-grow: 1;
`;

const SaveTextContainer = styled.div`
  color: ${Colors.text_primary};
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  cursor: pointer;
  ${(props) =>
    props.saveButtonDisabled &&
    `color: ${Colors.text_primary}30; cursor: not-allowed;`}
`;

export default {
  IconContainer,
  Header,
  HeaderTopItems,
  TitleContainer,
  SaveTextContainer,
};
